import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_select = _resolveComponent("q-select");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_q_select, {
            modelValue: _ctx.copy,
            "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event) => ((_ctx.copy) = $event)),
                _ctx.onUpdateValue
            ],
            dense: "",
            outlined: "",
            options: _ctx.filteredOptions,
            "map-options": "",
            "emit-value": "",
            "use-input": "",
            "input-debounce": "300",
            onFilter: _ctx.onFilter,
            "popup-content-style": { width: '10px' }
        }, null, 8, ["modelValue", "options", "onFilter", "onUpdate:modelValue"])
    ]));
}
